import React from "react";
import styles from "./tags.css";

export const TagList = ({ tags, className }) => {
	return (
		<div className={className}>
			{tags.map((tag, index) => <TagListItem key={index}>{tag}</TagListItem>)}
		</div>
	);
};

const TagListItem = ({ children }) => {
	return <span className={styles.tagListItem}>#{children}</span>;
};



// WEBPACK FOOTER //
// ./src/components/ui/tags/tags.js